import tradingFlow from './trading-flow.vue'

export default tradingFlow
